import api from './api';

const connectortrxsummaryService = {
  getAllConnectorTrxSummaries: async (filters = {}) => {
    try {
      const params = new URLSearchParams();
      if (filters.connectorid) params.append('connectorid', filters.connectorid);
      if (filters.accountid) params.append('accountid', filters.accountid);
      if (filters.period) params.append('period', filters.period);
      if (filters.trxtype) params.append('trxtype', filters.trxtype);

      const response = await api.get(`/connectortrxsummary?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching connector transaction summaries:', error);
      throw error;
    }
  },

  getConnectorTrxSummaryById: async (id) => {
    try {
      const response = await api.get(`/connectortrxsummary/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching connector transaction summary ${id}:`, error);
      throw error;
    }
  },

  createConnectorTrxSummary: async (summaryData) => {
    try {
      const cleanedData = Object.fromEntries(
        Object.entries(summaryData).map(([key, value]) => [
          key,
          value === '' ? null : value
        ])
      );

      const response = await api.post('/connectortrxsummary', cleanedData);
      return response.data;
    } catch (error) {
      console.error('Error creating connector transaction summary:', error);
      throw error;
    }
  },

  updateConnectorTrxSummary: async (id, summaryData) => {
    try {
      const cleanedData = Object.fromEntries(
        Object.entries(summaryData).map(([key, value]) => [
          key,
          value === '' ? null : value
        ])
      );

      const response = await api.put(`/connectortrxsummary/${id}`, cleanedData);
      return response.data;
    } catch (error) {
      console.error(`Error updating connector transaction summary ${id}:`, error);
      throw error;
    }
  },

  deleteConnectorTrxSummary: async (id) => {
    try {
      const response = await api.delete(`/connectortrxsummary/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting connector transaction summary ${id}:`, error);
      throw error;
    }
  }
};

export default connectortrxsummaryService;
